import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import messages from '../../messages.tsx';
import type { FormError, FieldErrors, CategoryGuid } from '../../types.tsx';
import {
	type ApolloErrorResponse,
	createCategory as createRest,
	type CreateCategoryRequest,
	updateCategory as updateRest,
	type UpdateCategoryRequest,
} from '../rest/categories/index.tsx';

export type TranslatedErrors = {
	formError: FormError | undefined;
	fieldErrors: FieldErrors;
};

// Ideally JSD Apollo would have i18n in their error messages, however in the absence of that
// we do a conversion here.
const errorKeyToMessage = {
	'jsd.apollo.error.limit.exceeded': messages.categoriesLimitExceeded,
	'jsd.apollo.error.project.permission.no.view.project.permission': messages.categoriesNoPermission,
	'jsd.apollo.field.error.category.name.cannot.be.blank': messages.categoriesNameFieldBlank,
	'jsd.apollo.field.error.category.exceeded.name.length': messages.categoriesNameFieldTooLong,
	'jsd.apollo.field.error.category.description.cannot.be.blank':
		messages.categoriesDescriptionFieldBlank,
	'jsd.apollo.field.error.category.exceeded.description.length':
		messages.categoriesDescriptionFieldTooLong,
} as const;

export const toErrors = (errorResponse: ApolloErrorResponse): TranslatedErrors => {
	const fieldErrorsResponse = errorResponse.fieldErrors || {};
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const fieldErrors = Object.keys(fieldErrorsResponse).reduce<Record<string, any>>(
		(acc, field) => ({
			// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
			...acc,
			[field]: {
				message:
					// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 'jsd.apollo.error.limit.exceeded': MessageDescriptorV2; readonly 'jsd.apollo.error.project.permission.no.view.project.permission': MessageDescriptorV2; readonly 'jsd.apollo.field.error.category.name.cannot.be.blank': MessageDescriptorV2;
					errorKeyToMessage[fieldErrorsResponse[field].errorKey] ||
					messages.categoriesGenericMessage,
			},
		}),
		{},
	);
	const formError = errorResponse.errorKey
		? {
				message:
					// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 'jsd.apollo.error.limit.exceeded': MessageDescriptorV2; readonly 'jsd.apollo.error.project.permission.no.view.project.permission': MessageDescriptorV2; readonly 'jsd.apollo.field.error.category.name.cannot.be.blank': MessageDescriptorV2;
					errorKeyToMessage[errorResponse.errorKey] || messages.categoriesGenericMessage,
			}
		: undefined;
	return {
		formError,
		fieldErrors,
	};
};

export const createCategory = (
	projectId: number,
	activationId: string,
	payload: CreateCategoryRequest,
) =>
	createRest(projectId, activationId, payload).catch((errorResponse) =>
		Observable.throw({ nativeError: errorResponse, formattedError: toErrors(errorResponse) }),
	);

export const updateCategory = (
	projectId: number,
	categoryId: CategoryGuid,
	activationId: string,
	payload: UpdateCategoryRequest,
) =>
	updateRest(projectId, categoryId, activationId, payload).catch((errorResponse) =>
		Observable.throw(toErrors(errorResponse)),
	);
